import api from "../../../processes/api";
import { getConfigInfo } from "./getConfigInfo";

export async function renderScene(closeFunc: any) {
  const info = await getConfigInfo();
  return await api.render.renderAndLoadImage(info, closeFunc);
}
